import * as v0 from "@aidkitorg/types/lib/survey";
import { InfoDict } from "./Questions/Props";

type LivenessFieldConfig = Partial<Pick<v0.LivenessDetection, 'identification' | 'selfie'>>;

/**
 * The image target fields a Liveness Detection node is expected to populate,
 * derived purely from its own config. Selfie-only nodes (no `identification`)
 * expect just the selfie field. Returns [] for legacy questions whose Metadata
 * doesn't carry the component config, so completeness falls back to the
 * targetField-only check.
 */
export function expectedLivenessFields(component: LivenessFieldConfig): string[] {
  return [
    component?.selfie?.targetField,
    ...(component?.identification
      ? [component.identification.front?.targetField, component.identification.back?.targetField]
      : [])
  ].filter((f): f is string => !!f);
}

/**
 * A liveness question only counts as complete when its own targetField holds a
 * non-pending value AND every image field it captures is still populated.
 * Guards against a done-timestamp outliving its outputs: a shared-targetField
 * Attachment deleting a photo, or a selfie-only Liveness node stamping the
 * same `liveness` field that a full front/back/selfie node relies on.
 */
export function isLivenessComplete(value: string | undefined, component: LivenessFieldConfig, info: InfoDict): boolean {
  if (!value || value.includes('pending')) return false;
  return expectedLivenessFields(component).every(f => !!info[f]);
}
